import { useSelector } from 'react-redux'
import Config from 'APP/Config'
import I18n from 'APP/Services/i18n'
import { selectPharmacies } from 'APP/Store/Pharmacies/selectors'
import { useNavigation } from '@react-navigation/native'
import { LimitedPharmacy } from '@dialogue/coredata'

interface EpharmacyExternalService {
  attributes?: {
    epharmacyIdentifier?: string
    province?: string
  }
}

/**
 * Navigates to the Pillway portal screen with the appropriate URL
 * @param {Object} navigation - The navigation object from useNavigation()
 * @param {Object} pharmacy - The pharmacy object from selectEpharmacyExternalServicesByProvider()
 * @param {Array} pharmacies - The list of pharmacies from selectPharmacies()
 * @param {String} [subRoute] - Optional sub-route to append to the Pillway URL.
 */
export const navigateToPillwayPortal = (
  // @ts-expect-error: navigation is not typed
  navigation,
  pharmacy: EpharmacyExternalService | null,
  pharmacies: LimitedPharmacy[] | null,
  subRoute: string | null = null
) => {
  if (!navigation) return
  if (!pharmacy || !pharmacies) return

  // Fetch province of epharmacy health resource from pharmacy list
  const province =
    pharmacies?.find((p) => p.external_id === pharmacy.attributes?.epharmacyIdentifier)
      ?.admin_area_level_1_iso_code ||
    pharmacy.attributes?.province ||
    ''

  // Generate full Pillway URL
  subRoute = subRoute || 'account'
  const url = `${Config.PILLWAY_DOMAIN}/#/${subRoute}?lang=${I18n.locale}&loc=${province}`

  // Navigate to Pillway webview
  navigation.navigate('pillwayPortalScreen', {
    navigationUrl: url,
  })
}

export const usePillwayNavigation = () => {
  const navigation = useNavigation()
  const pharmacies = useSelector(selectPharmacies)

  return (pharmacy: EpharmacyExternalService | null, subRoute?: string | null) => {
    navigateToPillwayPortal(navigation, pharmacy, pharmacies, subRoute)
  }
}
